import { ShieldCheck, BadgeCheck, Clock, Star } from "lucide-react";

const ICONS = [
  { icon: ShieldCheck, title: "25 lat gwarancji", desc: "na panele" },
  { icon: BadgeCheck, title: "Sprawdzony instalator", desc: "weryfikujemy partnerów" },
  { icon: Clock, title: "5–10 min reakcji", desc: "od pozostawienia numeru" },
];

export default function MicroProof() {
  return (
    <section
      className="py-12 lg:py-16 bg-white"
      data-testid="micro-proof-section"
      aria-label="Zaufanie i opinia"
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-5">
          {ICONS.map(({ icon: Icon, title, desc }) => (
            <div
              key={title}
              className="flex items-center gap-3 sm:gap-4 bg-brand-surface rounded-2xl p-4 sm:p-5 border border-brand-blue/10"
              data-testid={`microproof-${title.replace(/\s+/g, "-").toLowerCase()}`}
            >
              <div className="grid place-items-center h-11 w-11 rounded-full bg-white text-brand-blue flex-shrink-0 shadow-sm">
                <Icon className="h-5 w-5" strokeWidth={1.8} />
              </div>
              <div>
                <p className="font-heading font-bold text-brand-ink leading-tight">{title}</p>
                <p className="text-sm text-brand-muted mt-0.5">{desc}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Mini review */}
        <div className="mt-8 max-w-3xl mx-auto text-center" data-testid="mini-review">
          <div className="flex items-center justify-center gap-1">
            {[0, 1, 2, 3, 4].map((i) => (
              <Star key={i} className="h-5 w-5 fill-brand-yellow text-brand-yellow" />
            ))}
          </div>
          <p className="mt-3 font-heading text-lg sm:text-xl text-brand-ink leading-snug">
            “Doradca oddzwonił po 7 minutach, wycenę dostałam tego samego dnia. Konkretnie i bez nacisku.”
          </p>
          <p className="mt-2 text-sm text-brand-muted">
            — Anna K., Pruszków · 4,9/5 średnia ocena
          </p>
        </div>
      </div>
    </section>
  );
}
